import { useMediaQuery } from "#/hooks/use-media-query";

// Single source of truth for JS breakpoints, aligned with Tailwind's screens.
// Never call useMediaQuery with a raw pixel string in app code — if a new
// width is genuinely needed, add a named entry here so it has one definition.
export const BREAKPOINTS = {
  /** Tailwind `md` — the app's mobile/desktop boundary (drawer vs dialog). */
  md: 768,
  /** Tailwind `lg` — the sidebar collapse boundary. */
  lg: 1024,
  /** Non-Tailwind: wide-desktop column layout (modifiers list). */
  wide: 1200,
  /** Non-Tailwind: horizontal menu rail switch (menu-list-horizontal). */
  menuRail: 1308,
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

/** True when the viewport is at least the given breakpoint (min-width). */
export function useBreakpoint(bp: Breakpoint): boolean {
  return useMediaQuery(`(min-width: ${BREAKPOINTS[bp]}px)`);
}

/** True below the `md` breakpoint — the app's mobile/desktop boundary. */
export function useIsMobile(): boolean {
  return !useBreakpoint("md");
}
